// The default button hover style. Hover over the oplogg filter button to see an example
export const buttonHover = {
  border: "none",
  outlineStyle: "solid",
  background: "transparent !important",
  outlineWidth: "1px",
  outlineColor: "var(--spor-colors-core-outline);",
  _hover: {
    outlineWidth: "2px",
    outlineColor: "inherit",
  },
};
